/* eslint-disable vue/multi-word-component-names */
<template>
  <div class="login-page">
    <header class="topbar">
      <div class="topbar-inner">
        <div class="brand">TaskLink</div>
      </div>
    </header>

    <div class="stage">
      <div class="login-card">
        <div class="left-banner" aria-hidden="true"></div>

        <div class="right-form">
          <el-tabs v-model="activeTab" class="login-tabs" stretch>
            <el-tab-pane label="验证码登录" name="code">
              <el-form :model="form" class="form" label-position="top">
                <el-form-item label="手机号 / 邮箱">
                  <el-input v-model="form.account" placeholder="请输入手机号/邮箱" clearable>
                    <template #prefix>
                      <span class="ui-prefix-box">
                        <img class="ui-prefix" :src="iconAccount" alt="" />
                      </span>
                    </template>
                  </el-input>
                </el-form-item>

                <el-form-item label="验证码">
                  <el-input v-model="form.code" placeholder="验证码" clearable>
                    <!-- 你目前验证码 icon 注释了，这里保持空；需要的话照上面加同样结构 -->
                    <template #suffix>
                      <el-button class="code-btn" link type="success">获取验证码</el-button>
                    </template>
                  </el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="密码登录" name="password">
              <el-form :model="form" class="form" label-position="top">
                <el-form-item label="手机号 / 邮箱">
                  <el-input v-model="form.account" placeholder="请输入手机号/邮箱" clearable>
                    <template #prefix>
                      <span class="ui-prefix-box">
                        <img class="ui-prefix" :src="iconAccount" alt="" />
                      </span>
                    </template>
                  </el-input>
                </el-form-item>

                <el-form-item label="密码" class="password-item">
                  <el-input v-model="form.password" type="password" placeholder="请输入密码" show-password>
                    <template #prefix>
                      <span class="ui-prefix-box">
                        <img class="ui-prefix" :src="iconPassword" alt="" />
                      </span>
                    </template>
                  </el-input>

                  <!-- 忘记密码 -->
                  <div class="forgot-row">
                    <span class="forgot" @click="$router.push('/forgot')">忘记密码？</span>
                  </div>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>

          <el-button type="success" class="login-btn" @click="handleLogin">登 录</el-button>

          <div class="agreement">
            <el-checkbox v-model="agree" />
            <span class="agreement-text">
              我已阅读并同意
              <span class="a">《用户协议》</span>
              和
              <span class="a">《隐私政策》</span>
            </span>
          </div>

          <div class="bottom-link">
            <span class="register" @click="$router.push('/register')">注册账号</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import iconAccount from '../assets/iconAccount.png'
import iconPassword from '../assets/iconPassword.png'

const router = useRouter()
const activeTab = ref('code')
const agree = ref(false)

const form = reactive({
  account: '',
  code: '',
  password: '',
})

const handleLogin = () => {
  // localStorage.setItem('token', 'mock-token')
  router.push('/home')
}
</script>

<style scoped lang="scss">
/* =========================
   Theme
   ========================= */
$green: #4CAF50;
$green-hover: #2f9f35;
$text: #2f2f2f;
$muted: #6b7280;
$border: #e5e7eb;

.login-page {
  min-height: 100vh;
  background-image: url('../assets/未标题-1 1.png');
  display: flex;
  flex-direction: column;

  /* 顶部 TaskLink */
  .topbar {
    height: 88px;
    display: flex;
    align-items: center;
    background: #ffffffa6;

    .topbar-inner {
      width: min(1200px, calc(100% - 96px));
      margin: 0 auto;
    }

    .brand {
      font-family: 'Playfair Display', serif;
      font-weight: 500;
      font-size: 36px;
      color: #333333;
    }
  }

  /* 中间舞台 */
  .stage {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 72px 0 84px;
  }

  /* 卡片 */
  .login-card {
    width: 1247px;
    height: 640px;
    display: flex;
    overflow: hidden;
    border-radius: 14px;
    background: #fff;
    border: 1px solid rgba(230, 236, 232, 0.95);
    box-shadow: 0 10px 26px rgba(20, 30, 25, 0.1);

    .left-banner {
      width: 640px;
      background-image: url('../assets/Mask group.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    .right-form {
      flex: 1;
      padding: 48px 56px;
      display: flex;
      flex-direction: column;

      /* 忘记密码（在密码框下方） */
      .password-item {

        // Element Plus 会把内容包在 .el-form-item__content 里
        :deep(.el-form-item__content) {
          display: block; // 让 forgot-row 能换行到下一行
        }

        .forgot-row {
          margin-top: 8px;
          line-height: 1;
          text-align: left;
        }

        .forgot {
          font-weight: 500;
          font-size: 16px;
          color: $green; // 如果你没用变量，就写 #45b04a
          cursor: pointer;
          user-select: none;

          &:hover {
            color: $green-hover; // 没变量就写 #2f9f35
            text-decoration: underline;
          }
        }
      }

      /* ============= Tabs ============= */
      .login-tabs {
        --tl-green: #{$green};

        :deep(.el-tabs__header) {
          margin: 0 0 26px 0;
        }

        :deep(.el-tabs__nav-wrap::after) {
          height: 1px;
          background: #e9efe9;
        }

        :deep(.el-tabs__nav) {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }

        :deep(.el-tabs__item) {
          height: 36px;
          line-height: 36px;
          padding: 0;
          font-size: 16px;
          color: $text !important;

          &:hover {
            color: $green !important;
            /* 修复 hover 还是蓝色 */
          }

          &.is-active {
            color: $green !important;
            font-weight: 600;
          }

          &:focus-visible {
            outline: none !important;
            box-shadow: none !important;
          }
        }

        :deep(.el-tabs__active-bar) {
          height: 2px;
          border-radius: 2px;
          background: $green !important;
        }
      }

      /* ============= Form ============= */
      .form {
        margin-top: 2px;

        :deep(.el-form-item) {
          margin-bottom: 32px;
        }

        :deep(.el-form-item__label) {
          padding: 0 0 8px;
          line-height: 1.2;
          font-size: 14px;
          color: #374151;
        }
      }

      /* ============= Input (Element Plus) ============= */
      :deep(.el-input__wrapper) {
        height: 56px;
        padding: 0 12px;
        border-radius: 6px;
        background: #fff !important;
        border: none !important;
        box-shadow: none !important;

        position: relative;
        /* 给 ::after 用 */
        overflow: visible !important;
      }

      /* 用 ::after 画边框，避免被 suffix/prefix/填充遮挡 */
      :deep(.el-input__wrapper::after) {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 6px;
        pointer-events: none;
        border: 1px solid #D1D5DB;
        z-index: 1 !important;
        /* 不要太高，避免影响 checkbox 点击 */
      }

      :deep(.el-input__wrapper.is-focus::after) {
        border-color: rgba(69, 176, 74, 0.65);
      }

      :deep(.el-input__inner) {
        height: 56px;
        line-height: 56px;
        font-size: 16px;
        background: transparent !important;
      }

      /* prefix/suffix 透明，防止盖住边框 */
      :deep(.el-input__prefix),
      :deep(.el-input__suffix),
      :deep(.el-input__suffix-inner),
      :deep(.el-input__password) {
        background: transparent !important;
        box-shadow: none !important;
      }

      /* autofill 背景压制 */
      :deep(input.el-input__inner:-webkit-autofill),
      :deep(input.el-input__inner:-webkit-autofill:hover),
      :deep(input.el-input__inner:-webkit-autofill:focus),
      :deep(input.el-input__inner:-webkit-autofill:active),
      :deep(.el-input__wrapper input:-webkit-autofill) {
        -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
        box-shadow: 0 0 0 1000px #fff inset !important;
        -webkit-text-fill-color: #111827 !important;
        caret-color: #111827;
        transition: background-color 99999s ease-in-out 0s;
      }

      /* ============= Prefix Icon ============= */
      .ui-prefix-box {
        width: 16px;
        height: 16px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .ui-prefix {
        width: 20px;
        height: 20px;
        display: block;
        opacity: 0.85;
        image-rendering: pixelated;
      }

      :deep(.el-input__prefix) {
        display: inline-flex;
        align-items: center;
        margin-right: 6px;
      }

      /* ============= Code Button ============= */
      .code-btn {
        font-weight: 500;
        font-size: 16px;
        color: #4CAF50;
        padding: 0 12px;

        &:hover {
          color: $green-hover;
        }
      }

      /* ============= Primary Button ============= */
      .login-btn {
        margin-top: 6px;
        height: 48px;
        border-radius: 4px;
        font-size: 16px;
        letter-spacing: 4px;
        background: $green;
        border-color: $green;

        &:hover {
          background: #3aa842;
          border-color: #3aa842;
        }
      }

      /* ============= Agreement (checkbox) ============= */
      .agreement {
        margin-top: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #374151;
        font-size: 14px;

        position: relative;
        z-index: 2;
        /* 保证可点 */
      }

      :deep(.el-checkbox) {
        position: relative;
        z-index: 2;
        pointer-events: auto;
      }

      :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
        background-color: $green !important;
        border-color: $green !important;
      }

      :deep(.el-checkbox__input .el-checkbox__inner:hover) {
        border-color: $green !important;
      }

      .agreement-text {
        .a {
          color: $green;
          cursor: pointer;

          &:hover {
            color: $green-hover;
          }
        }
      }

      /* ============= Bottom Link ============= */
      .bottom-link {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 22px;
      }

      .register {
        font-weight: 500;
        font-size: 16px;
        color: $green;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

/* 响应式 */
@media (max-width: 1240px) {
  .login-page {
    .login-card {
      width: min(96vw, 980px);
    }

    .login-card .right-form {
      padding: 44px 52px 36px;
    }
  }
}

@media (max-width: 980px) {
  .login-page {
    .login-card {
      height: auto;
      flex-direction: column;

      .left-banner {
        height: 260px;
        width: 100%;
      }
    }
  }
}
</style>